<div class="h-full flex flex-col bg-gray-200">

  <!-- Header -->
  <div class="flex-none">
    <app-header></app-header>
  </div>

  <!-- Colonna principale -->
  <div class="flex flex-col p-3 space-y-2 flex-grow min-h-0">

    <!-- Card info -->
    <div class="flex-none bg-white rounded-lg">
      <app-card-info></app-card-info>
    </div>

    <!-- Area mappa -->
    <div class="relative flex-grow min-h-0">

      <!-- Sidebar sx -->
      <app-sidebar-left></app-sidebar-left>

      <!-- Mappa -->
      <app-map></app-map>

      <!-- Sidebar dx -->
      <app-anagrafica-modal></app-anagrafica-modal>

    </div>

  </div>
  <div  class="footer">
    <app-footer></app-footer>
  </div>
</div>